import { GroupPostAttributesType } from '../../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { PostStatus } from '../../../../models/graphql';

export const severityResolver = (post: GroupPostAttributesType, severity: ErrorMessageSeverity): ErrorMessageSeverity =>
  post.postStatus === PostStatus.DRAFT ? ErrorMessageSeverity.warning : severity;
